import { DataTableAlign, DataTableColumn } from './DataTable.types'

export type ColumnOverrides = { align?: DataTableAlign; width?: number; tooltip?: string }

const toTime = (value?: Date | string | null) => {
    if (!value) return undefined

    const time = value instanceof Date ? value.getTime() : new Date(value).getTime()

    return Number.isNaN(time) ? undefined : time
}

export const textColumn = <TRow, TColumnId extends string>(
    id: TColumnId,
    label: string,
    getValue: (row: TRow) => string | undefined,
    overrides?: ColumnOverrides
): DataTableColumn<TRow, TColumnId> => ({ id, label, getSortValue: getValue, ...overrides })

/** Takes a Date or the string a record stores, so a table need not parse before it sorts. */
export const dateColumn = <TRow, TColumnId extends string>(
    id: TColumnId,
    label: string,
    getValue: (row: TRow) => Date | string | null | undefined,
    overrides?: ColumnOverrides
): DataTableColumn<TRow, TColumnId> => ({
    id,
    label,
    align: 'center',
    getSortValue: (row) => toTime(getValue(row)),
    ...overrides,
})

export const countColumn = <TRow, TColumnId extends string>(
    id: TColumnId,
    label: string,
    getValue: (row: TRow) => number,
    overrides?: ColumnOverrides
): DataTableColumn<TRow, TColumnId> => ({ id, label, align: 'center', getSortValue: getValue, ...overrides })

/** Sorts on the negated value, so Yes comes before No. */
export const yesNoColumn = <TRow, TColumnId extends string>(
    id: TColumnId,
    label: string,
    getValue: (row: TRow) => boolean,
    overrides?: ColumnOverrides
): DataTableColumn<TRow, TColumnId> => ({
    id,
    label,
    align: 'center',
    getSortValue: (row) => !getValue(row),
    ...overrides,
})
